var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dealer-a{fill:url(#a);}.dealer-b{fill:url(#b);}.dealer-c{fill:url(#d);}.dealer-d{opacity:0.2;}.dealer-e{fill:#fff;opacity:0.5;}.dealer-f{fill:url(#e);}.dealer-g{fill:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 1,
    x2: 1,
    y2: -0.894,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f5d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#ffc710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d540e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.228,
    y1: 0.338,
    x2: 1.028,
    y2: 1.238,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#fff",
    stopOpacity: 0.271
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#fff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#fff",
    stopOpacity: 0.224
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#947512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d3005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dealer-a",
    d: "M16,5.67c-.058,3-3.626,5.284-8.057,5.228-4.777-.056-8-2.67-7.942-5.673S3.625-.114,8.056,0,16.056,2.667,16,5.67Z",
    transform: "translate(0.001 1.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-b",
    d: "M7.941,15.325C3.165,15.267-.058,12.537,0,9.4v1.917c0,3.369,3.51,5.983,7.942,6.1S16,14.977,16,11.782V9.865C16,13,12.372,15.325,7.941,15.325Z",
    transform: "translate(0.001 -4.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-a",
    d: "M16,5.67c-.058,3-3.626,5.284-8.057,5.228-4.777-.056-8-2.67-7.942-5.673S3.625-.114,8.056,0,16.056,2.667,16,5.67Z",
    transform: "translate(0.001 0.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-c",
    d: "M16,5.67c-.058,3-3.626,5.284-8.057,5.228-4.777-.056-8-2.67-7.942-5.673S3.625-.114,8.056,0,16.056,2.667,16,5.67Z",
    transform: "translate(0.001 0.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-d",
    d: "M16,11.652c-.058,3.253-3.626,5.751-8.057,5.635S0,14.557,0,11.188v.465c0,3.369,3.51,5.983,7.942,6.1S16,15.312,16,12.117V10.2h0Z",
    transform: "translate(0.001 -4.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-e",
    d: "M7.941,14.66C3.28,14.6.172,12.081,0,9.1v.172c-.058,3.1,3.165,5.789,7.942,5.789,4.431,0,8.057-2.293,8.057-5.388V9.387C15.825,12.424,12.257,14.66,7.941,14.66Z",
    transform: "translate(0.001 -4.154)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.154 1.921)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dealer-f",
    d: "M9.692,3.3a3.575,3.575,0,0,1,3.763,3.012h0c.367,1.617-.6,3.067-3.855,3.067H5.7c.367-2.008.78-4.071,1.147-6.079ZM7.949,8.1H9.555c1.56,0,2.065-.613,1.973-1.729h0C11.436,5.14,10.886,4.638,9.6,4.638H8.316Z",
    transform: "translate(-5.7 -3.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dealer-g",
    d: "M9.692,3.3a3.575,3.575,0,0,1,3.763,3.012h0c.367,1.617-.6,3.067-3.855,3.067H5.7c.367-2.008.78-4.071,1.147-6.079ZM7.949,8.1H9.555c1.56,0,2.065-.613,1.973-1.729h0C11.436,5.14,10.886,4.638,9.6,4.638H8.316Z",
    transform: "translate(-5.7 -3.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerChip);
export default __webpack_public_path__ + "static/media/dealer-chip.07d1123e76fc9a905e4aa2b991f409bb.svg";
export { ForwardRef as ReactComponent };